/**
 * extracts the localized value of an i18n message
 * @param message - value of localization dictionary that can either be a string or object with value and context fields
 * @returns localized string
 */
export const extractTranslationValue = (message: i18n.TranslationMapValue): string => {
  return typeof message === 'string' ? message : message.value
}
